import React from "react";

export function Donate(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.9466 3.00212C15.7755 2.83396 15.5724 2.70056 15.3489 2.60954C15.1254 2.51853 14.8858 2.47168 14.6439 2.47168C14.4019 2.47168 14.1624 2.51853 13.9388 2.60954C13.7153 2.70056 13.5123 2.83396 13.3412 3.00212L12.9862 3.35096L12.6313 3.00212C12.2858 2.6626 11.8172 2.47186 11.3286 2.47186C10.84 2.47186 10.3714 2.6626 10.0259 3.00212C9.68042 3.34165 9.48633 3.80214 9.48633 4.2823C9.48633 4.76246 9.68042 5.22296 10.0259 5.56248L10.3809 5.91132L12.9862 8.47168L15.5916 5.91132L15.9466 5.56248C16.1177 5.39439 16.2534 5.19482 16.346 4.97516C16.4387 4.75551 16.4863 4.52007 16.4863 4.2823C16.4863 4.04454 16.4387 3.8091 16.346 3.58944C16.2534 3.36978 16.1177 3.17021 15.9466 3.00212Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9727 15.5286H13.9727C14.5031 15.5286 15.0118 15.3179 15.3869 14.9428C15.7619 14.5677 15.9727 14.059 15.9727 13.5286C15.9727 12.9982 15.7619 12.4895 15.3869 12.1144C15.0118 11.7393 14.5031 11.5286 13.9727 11.5286H10.9727C10.3727 11.5286 9.87266 11.7286 9.57266 12.1286L3.97266 17.5286M7.97266 21.5286L9.57266 20.1286C9.87266 19.7286 10.3727 19.5286 10.9727 19.5286H14.9727C16.0727 19.5286 17.0727 19.1286 17.7727 18.3286L22.3727 13.9286C22.7585 13.5639 22.9838 13.0609 22.9988 12.5302C23.0138 11.9994 22.8173 11.4845 22.4527 11.0986C22.088 10.7127 21.585 10.4875 21.0542 10.4725C20.5235 10.4575 20.0085 10.6539 19.6227 11.0186L15.4227 14.9186M2.97266 16.5286L8.97266 22.5286"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
